import React, { useEffect } from 'react';
import './style.css';
import { useState } from 'react';
import { Fragment } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { SelectButton } from 'primereact/selectbutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { notificationType } from '../../common/util/constants';
import { notificationService } from '../../services/extensions';
import { confirmDialog } from 'primereact/confirmdialog';
import { Util } from '../../services';
import { Calendar } from 'primereact/calendar';

const NotificationCard = () => {
  const [allocationNotification, setAllocationNotification] = useState([]);
  const [timesheetNotification, setTimesheetNotification] = useState([]);
  const [leaveNotification, setLeaveNotification] = useState([]);
  const [payrollNotification, setPayrollNotification] = useState([]);
  const [userNotification, setUserNotification] = useState([]);
  const [othersNotification, setOthersNotification] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [allocationNotif, setAllocationNotif] = useState("Allocation");
  const [allocationAction, setAllocationAction] = useState(true);
  const [timesheetAction, setTimesheetAction] = useState(false);
  const [leaveAction, setLeaveAction] = useState(false);
  const [payrollAction, setPayrollAction] = useState(false);
  const [userAction, setUserAction] = useState(false);
  const [othersAction, setOthersAction] = useState(false);
  const [closeDialog, setCloseDialog] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [selectedOption, setselectedOption] = useState("Current Week");
  const [showCalender, setShowCalender] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [filterNotification, setFilterNotification] = useState([]);
  const dateOptions = ["Current Week", "Last 3 Week", "Custom"];


  const options = [
    { count: allocationNotification.length, value: 'Allocation' },
    { count: timesheetNotification.length, value: 'Timesheet' },
    { count: leaveNotification.length, value: 'Leave' },
    { count: payrollNotification.length, value: 'Payroll' },
    { count: userNotification.length, value: 'User' },
    { count: othersNotification.length, value: 'Others' }
  ];

  useEffect(() => {
    getNotification();
  }, [])

  const getNotification = () => {
    notificationService.getNotification().then(resp => {
      try {
        const timesheetNotify = resp.data.data.filter((x) => {
          return x.type === 0;
        });
        setTimesheetNotification(timesheetNotify);
        const allocationNotify = resp.data.data.filter((x) => {
          return x.type === 1;
        });
        setAllocationNotification(allocationNotify);
        const leaveNotify = resp.data.data.filter((x) => {
          return x.type === 2;
        });
        setLeaveNotification(leaveNotify);
        const payrollNotify = resp.data.data.filter((x) => {
          return x.type === 3;
        });
        setPayrollNotification(payrollNotify);
        const userNotify = resp.data.data.filter((x) => {
          return x.type === 4;
        });
        setUserNotification(userNotify);
        const othersNotify = resp.data.data.filter((x) => {
          return x.type === 5;
        });
        setOthersNotification(othersNotify);
      } catch (error) { }
    });
  };

  const deleteNotification = (e, row) => {
    confirmDialog({
      target: e.currentTarget,
      message: 'Are you sure you want to delete?',
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      reject: () => {
        notificationService.deleteNotification(row.id).then(resp => {
          getNotification();
        }, (error) => {
        })
      },
      accept: () => {
      }
    })
  }

  const onCloseMethod = () => {
    setCloseDialog(false);
  };

  const accept = () => {
    onCloseMethod();
  };

  const deleteAllNotification = () => {
    confirmDialog({
      message: 'Are you sure you want to delete selected data?',
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: "p-button-primary",
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      accept,
      reject,
    });
  }

  const reject = () => {
    var idList = [];
    selectedNotification.map((item, key) => {
      idList[key] = item.id;
    })
    let param = {
      ids: idList
    }
    notificationService.deleteAllNotification(param).then(resp => {
      setSelectedNotification(null);
      getNotification();
    });
  };

  const changeTab = (e) => {
    setAllocationNotif(e.value);
    const tab = e.value;
    setDateRange([]);
    setShowCalender(false);
    switch (tab) {
      case "Allocation":
        setAllocationAction(true);
        setTimesheetAction(false);
        setLeaveAction(false);
        setPayrollAction(false);
        setUserAction(false);
        setOthersAction(false);
        break;

      case "Timesheet":
        setTimesheetAction(true);
        setAllocationAction(false);
        setLeaveAction(false);
        setPayrollAction(false);
        setUserAction(false);
        setOthersAction(false);
        break;

      case "Leave":
        setLeaveAction(true);
        setAllocationAction(false);
        setTimesheetAction(false);
        setPayrollAction(false);
        setUserAction(false);
        setOthersAction(false);
        break;

      case "Payroll":
        setPayrollAction(true);
        setAllocationAction(false);
        setTimesheetAction(false);
        setLeaveAction(false);
        setUserAction(false);
        setOthersAction(false);
        break;

      case "User":
        setUserAction(true);
        setAllocationAction(false);
        setTimesheetAction(false);
        setLeaveAction(false);
        setPayrollAction(false);
        setOthersAction(false);
        break;

      case "Others":
        setOthersAction(true);
        setAllocationAction(false);
        setTimesheetAction(false);
        setLeaveAction(false);
        setPayrollAction(false);
        setUserAction(false);
        break;

      default:
        setAllocationAction(true);
        setTimesheetAction(false);
        setLeaveAction(false);
        setPayrollAction(false);
        setUserAction(false);
        setOthersAction(false);
        break;
    }
  };

  const filterNotificationWithDate = (from_dt = "", to_dt = "") => {
    let param = {
      from_date: from_dt,
      to_date: Util.dateConverter(to_dt)
    };
    notificationService.filterNotificationAccordingToDate(param).then((resp) => {
      try {
        setFilterNotification(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };


  const filterTab = (e) => {
    setselectedOption(e.value);
    const tab = e.value;
    switch (tab) {
      case "Current Week":
        setShowCalender(false);
        let curr = new Date();
        let selectedPastDate;
        selectedPastDate = Util.pastDays(curr, 7);
        filterNotificationWithDate(selectedPastDate, curr);
        break;

      case "Last 3 Week":
        setShowCalender(false);
        let curr1 = new Date();
        let selectedPastDate1;
        selectedPastDate1 = Util.pastDays(curr1, 21);
        filterNotificationWithDate(selectedPastDate1, curr1);
        break;

      case "Custom":
        showCalender ? setShowCalender(false) : setShowCalender(true);
        break;

      default:
        break;
    }
  };

  const justifyTemplate = (option) => {
    return option.value + "-" + option.count;
  }

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <SelectButton
          value={allocationNotif}
          options={options}
          onChange={(e) => changeTab(e)}
          itemTemplate={justifyTemplate}
        />
        {showCalender && (
          <div className='ml-6'>
            <Calendar
              id="range"
              value={dateRange}
              onChange={(e) => {
                setDateRange(e.value)
                if (e.value[1] !== null) {
                  let from_dt = Util.dateConverter(e.value[0]);
                  let to_dt = e.value[1];
                  filterNotificationWithDate(from_dt, to_dt);
                }
              }}
              selectionMode="range"
              readOnlyInput
              dateFormat="dd/mm/yy"
              mask="99/99/9999"
              showIcon
              placeholder="Select date range"
            />
          </div>
        )}
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <SelectButton
          value={selectedOption}
          options={dateOptions}
          onChange={(e) => filterTab(e)}
        />
      </React.Fragment>
    );
  };

  const notificationBody = (item) => {
    return (
      <React.Fragment>
        <div className='grid'>
          <span className='notification-image'>{item.title.toUpperCase().substr(0, 1)}</span>
          <div className='col-8'>
            <div style={{ color: 'black' }} className='mt-1'><strong>{item.title}</strong></div>
            <div style={{ color: 'black' }}>{item.description}</div>
            <div style={{ color: 'rgb(128,128,128)' }}>{Util.dateConverterUS(item.createdAt, true)}</div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const deleteTemplate = (row) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          onClick={(e) => deleteNotification(e, row)}
          className="p-button-rounded p-button-outlined p-button-danger"
          style={{ float: 'right' }}
        />
      </React.Fragment>
    );
  };

  const deleteAllButton = () => {
    return (
      <div>
        <Button
          type="button"
          label="Delete All"
          icon="pi pi-trash"
          disabled={disabled}
          onClick={() => deleteAllNotification()}
          className="p-button-rounded p-button-danger"
        />
      </div>
    )
  }

  const deleteAllTemplate = (length) => {
    if (length) {
      return deleteAllButton();
    }
  }

  const onCheckNotification = (e) => {
    setSelectedNotification(e.value);
    if (e.value.length > 0) {
      setDisabled(false);
    }
  };

  const AllocationTemplate = () => {
    return (
      <Card>
        <React.Fragment>
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            value={allocationNotification}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedNotification}
            onSelectionChange={(e) => onCheckNotification(e)}
            dataKey="id"
          >
            <Column
              selectionMode={allocationNotification.length ? "multiple" : ""}
              headerStyle={{ width: "1rem" }}
              exportable={false}
            ></Column>
            <Column
              field=""
              header={deleteAllTemplate(allocationNotification.length)}
              body={notificationBody}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header=""
              body={deleteTemplate}
            ></Column>
          </DataTable>
        </React.Fragment>
      </Card>
    );
  };

  const TimesheetTemplate = () => {
    return (
      <Card>
        <React.Fragment>
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            value={timesheetNotification}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedNotification}
            onSelectionChange={(e) => onCheckNotification(e)}
            dataKey="id"
          >
            <Column
              selectionMode={timesheetNotification.length ? "multiple" : ""}
              headerStyle={{ width: "1rem" }}
              exportable={false}
            ></Column>
            <Column
              field=""
              header={deleteAllTemplate(timesheetNotification.length)}
              body={notificationBody}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header=""
              body={deleteTemplate}
            ></Column>
          </DataTable>
        </React.Fragment>
      </Card>
    );
  };

  const LeaveTemplate = () => {
    return (
      <Card>
        <React.Fragment>
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            value={leaveNotification}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedNotification}
            onSelectionChange={(e) => onCheckNotification(e)}
            dataKey="id"
          >
            <Column
              selectionMode={leaveNotification.length ? "multiple" : ""}
              headerStyle={{ width: "1rem" }}
              exportable={false}
            ></Column>
            <Column
              field=""
              header={deleteAllTemplate(leaveNotification.length)}
              body={notificationBody}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header=""
              body={deleteTemplate}
            ></Column>
          </DataTable>
        </React.Fragment>
      </Card>
    );
  };

  const PayrollTemplate = () => {
    return (
      <Card>
        <React.Fragment>
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            value={payrollNotification}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedNotification}
            onSelectionChange={(e) => onCheckNotification(e)}
            dataKey="id"
          >
            <Column
              selectionMode={payrollNotification.length ? "multiple" : ""}
              headerStyle={{ width: "1rem" }}
              exportable={false}
            ></Column>
            <Column
              field=""
              header={deleteAllTemplate(payrollNotification.length)}
              body={notificationBody}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header=""
              body={deleteTemplate}
            ></Column>
          </DataTable>
        </React.Fragment>
      </Card>
    );
  };

  const UserTemplate = () => {
    return (
      <Card>
        <React.Fragment>
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            value={userNotification}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedNotification}
            onSelectionChange={(e) => onCheckNotification(e)}
            dataKey="id"
          >
            <Column
              selectionMode={userNotification.length ? "multiple" : ""}
              headerStyle={{ width: "1rem" }}
              exportable={false}
            ></Column>
            <Column
              field=""
              header={deleteAllTemplate(userNotification.length)}
              body={notificationBody}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header=""
              body={deleteTemplate}
            ></Column>
          </DataTable>
        </React.Fragment>
      </Card>
    );
  };

  const OthersTemplate = () => {
    return (
      <Card>
        <React.Fragment>
          <DataTable
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            value={othersNotification}
            rowsPerPageOptions={[10, 20, 50]}
            selection={selectedNotification}
            onSelectionChange={(e) => onCheckNotification(e)}
            dataKey="id"
          >
            <Column
              selectionMode={othersNotification.length ? "multiple" : ""}
              headerStyle={{ width: "1rem" }}
              exportable={false}
            ></Column>
            <Column
              field=""
              header={deleteAllTemplate(othersNotification.length)}
              body={notificationBody}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header=""
              body={deleteTemplate}
            ></Column>
          </DataTable>
        </React.Fragment>
      </Card>
    );
  };

  return (
    <Fragment>
      <div className='notification'>
        <h3 className='mb-3 ml-1'>Notification</h3>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate} />
        {allocationAction && <AllocationTemplate />}
        {timesheetAction && <TimesheetTemplate />}
        {leaveAction && <LeaveTemplate />}
        {payrollAction && <PayrollTemplate />}
        {userAction && <UserTemplate />}
        {othersAction && <OthersTemplate />}
      </div>
    </Fragment>
  );
}

export default NotificationCard;